module.exports = __webpack_public_path__ + "static/img/frontPage.409400eb.png";